import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=29575a78&"
import script from "./Loading.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Loading.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Loading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports